module.exports = __webpack_public_path__ + "img/LU.c6c7468b.svg";